import React from "react";
import { CoObjectItem } from "../../interfaces/CoObject";
import { ObjectPanelComponent } from "../co-panel/ObjectPanelComponent";
import useObjectPanel from "./ObjectPanelHook";

export interface ObjectProps {
  isEdit: boolean;
  coObject: CoObjectItem;
}

export const ObjectPanel: React.FunctionComponent<ObjectProps> = (props) => {
  const { coObject, isEdit, updateCoObject, saveCoObject, validator, originalSheetArea, setOriginalSheetArea } =
    useObjectPanel(props);

  return (
    <>
      {coObject ? (
        <ObjectPanelComponent
          isEdit={isEdit}
          isComponentInstance={coObject?.info?.componentReference !== undefined}
          saveCoObject={updateCoObject}
          coObject={coObject}
          onSaveBtn={saveCoObject}
          validator={validator}
          isLocked={coObject.isLocked}
          originalSheetArea={originalSheetArea}
          setOriginalSheetArea={setOriginalSheetArea}
        />
      ) : null}
    </>
  );
};
